import { Button } from "@/modules/shadcn/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogTitle,
} from "@/modules/shadcn/ui/dialog";
import { useTranslation } from "react-i18next";
import { EvalActionsSection } from "../EvalActions";
import { useTestCaseForm } from "./useTestCaseForm.hook";

export type CreateTestCaseModalProps = {
  projectId: number;
  configId: number;
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

export const CreateTestCaseModal = ({
  projectId,
  configId,
  open,
  onOpenChange,
}: CreateTestCaseModalProps) => {
  const { t } = useTranslation(["evaluation", "common"]);
  const { form, isSubmitting } = useTestCaseForm({
    projectId,
    configId,
    onSuccess: () => onOpenChange(false),
  });

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-2xl">
        <DialogTitle className="text-xl font-semibold">
          {t("testCaseForm.addTitle")}
        </DialogTitle>

        <form.AppForm>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              e.stopPropagation();
              form.handleSubmit();
            }}
            className="flex flex-col gap-6"
          >
            <div className="flex flex-col gap-3">
              <h6 className="text-sm font-bold">{t("form.general")}</h6>

              <form.AppField
                name="enabled"
                children={(field) => <field.Switch label={t("form.enabled")} />}
              />

              <form.AppField name="name">
                {(field) => (
                  <field.TextInput
                    label={t("form.name")}
                    placeholder={t("testCaseForm.namePlaceholder")}
                  />
                )}
              </form.AppField>
            </div>

            <EvalActionsSection />

            <div className="flex justify-end gap-2">
              <DialogClose
                render={<Button type="button" variant="outline" size="lg" />}
              >
                {t("common:actions.cancel")}
              </DialogClose>
              <Button type="submit" size="lg" disabled={isSubmitting}>
                {t("common:actions.save")}
              </Button>
            </div>
          </form>
        </form.AppForm>
      </DialogContent>
    </Dialog>
  );
};
